import * as React from 'react';

import {G, Mask, Path} from 'react-native-svg';

import Icon from './Icon';
import {IconProps} from './type';

const StarIcon: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <Mask
        id="a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}>
        <Path fill="#fff" d="M24 0H0v24h24V0Z" />
      </Mask>
      <G mask="url(#a)">
        <Path
          stroke="#100E3A"
          strokeWidth={0.5}
          d="M11.817 2.462c.067-.142.237-.16.33-.052l.035.053 2.541 5.386c.185.392.523.683.927.799l.178.038 5.683.864c.137.021.225.196.153.333l-.041.057-4.113 4.193a1.55 1.55 0 0 0-.437 1.158l.02.183.97 5.921c.03.183-.12.285-.243.26l-.05-.018-5.084-2.796a1.42 1.42 0 0 0-1.209-.077l-.164.077-5.084 2.796c-.112.061-.279-.01-.296-.169l.003-.073.972-5.92c.07-.43-.04-.867-.299-1.204l-.12-.138L2.377 9.94a.236.236 0 0 1 .055-.372l.056-.018 5.684-.864a1.46 1.46 0 0 0 1.015-.674l.088-.162 2.542-5.388Z"
        />
      </G>
    </Icon>
  );
};

export default StarIcon;
